import React from 'react';

const FavoriteProjectComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">What have been some of your favorite side project?</h1>
      <ul className="categoried-list">
        <li>Many companies look at a candidate&apos;s side projects in order to gage a candidate&apos;s passion for engineering, initiative, skill, and a love for continuous improvement.</li>
        <li>Provide a brief summary of what you built, technical challenges you overcame, and the impact your project had.</li>
        <li>Be sure to add a link to the project if applicable!</li>
      </ul>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">Property enumeration solution for Spatial Matrix Limited</p>
        <p style={{ marginBottom: '0px' }}>April 2018 - February 2019</p>
        <p className="light-grey-text project-link">https://github.com/turingcom</p>
        <ul className="categoried-list">
          <li>Developed web app frontend using Angular (6) for users authentication, create users, work schedule, and data export tool.</li>
          <li>Developed a highly maintainable RESTful api using Node.js following best practices to handle business logic and data storage in MongoDB.</li>
          <li>The solution helped Spatial Matrix to capture data on over 200,000 properties, reduced field agents from over 800 to 200, reduce data collection and processing time from several months to few hours, and greatly reduced overall project cost.</li>
          <li>2020 Azure Solution Architect Expert</li>
        </ul>
        <p className="alt-text">Technologies used: Angular, REST/RESTful APIs, Node.js, MongoDB</p>
      </div>
    </div>
  );
};

export default FavoriteProjectComponent;
